import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import CooperationForm from "../../components/Cooperations/CooperationForm";
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";

const CooperationsCreate = ({classes, board, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('appointments.new_contract')}
        />

        <Paper>
            <CardContent>
                <CooperationForm
                    board={board}
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default CooperationsCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/cooperations/Create.jsx